import { Outlet } from 'react-router';
import { lazy, Suspense } from 'react';

import { AlvineBackLayout } from 'src/layouts/simple';

import { LoadingScreen } from 'src/components/loading-screen';

const QrCodeInfoPage = lazy(() => import('src/pages/qr-code/info'));
const QrCodeLessonPage = lazy(() => import('src/pages/qr-code/lesson'));
const QrCodeRedirectPage = lazy(() => import('src/pages/qr-code/redirect'));

export const qrCodeRoutes = [
  {
    path: 'qr-code',
    element: (
      <AlvineBackLayout>
        <Suspense fallback={<LoadingScreen />}>
          <Outlet />
        </Suspense>
      </AlvineBackLayout>
    ),
    children: [
      {
        path: 'info',
        element: <QrCodeInfoPage />,
      },
      {
        path: 'lesson/:lessonId',
        element: <QrCodeLessonPage />,
      },
      {
        path: 'r/:code',
        element: <QrCodeRedirectPage />,
      },
    ],
  },
];
